import { Link, useParams } from 'react-router-dom'
import { categories } from '../../data/shop/products'
import { useCart } from '../../context/CartContext'

export function ShopNav(){
  const {category}=useParams();const {count,openCart}=useCart()
  return <nav className="shop-nav" aria-label="Shop navigation"><div className="container"><Link to="/shop">Shop</Link><div className="shop-nav__categories">{categories.map(([id,label])=><Link className={(category??'all')===id?'active':''} to={id==='all'?'/shop':`/shop/${id}`} key={id}>{label}</Link>)}</div><button type="button" onClick={openCart} aria-label={`Open cart with ${count} items`}><span className="shop-bag" aria-hidden="true"/>Bag ({count})</button></div></nav>
}
